module.exports = __webpack_public_path__ + "img/pantalla-8-4.c0c52401.png";